import { ModalAddPagoComponent } from './../modal-add-pago/modal-add-pago/modal-add-pago.component';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ReversaPagoService } from 'src/app/services/reversa-pago.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { DatesService } from "src/app/shared/services/dates.service";

@Component({
  selector: 'app-reverso-pagos-modal-add-edit',
  templateUrl: './modal-add-edit-reverso-pago.component.html',
  styleUrls: ['./modal-add-edit-reverso-pago.component.scss'],
  providers: [SecurityService],
})
export class ModalAddEditReversoPagoComponent implements OnInit {

  // Modales
  @ViewChild('agregarReversoPago', { static: true }) modalReversoPago: ModalDirective;
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalAddPagoComponent, { static: true }) modalSeleccionarPago: ModalAddPagoComponent

  // Output
  @Output() onSave: EventEmitter<any> = new EventEmitter()

  // Form
  formData: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  private rutUsuario: number
  clienteSeleccionado: any = null
  pagoSeleccionado: any = null
  isEditing: boolean = true

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private reversaPagoService: ReversaPagoService,
    private datesService: DatesService,
  ) {
    this.log = this.clog.log('MODAL-REVERSO-PAGOS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario())

    this.createForm()
    this.formChangesSubscriptions()
  }

  private createForm() {
    const { currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData = this.fb.group({
      rutCliente: [null, [Validators.required]],
      nroPago: [null, [Validators.required]],
      motivo: [null, [Validators.required]],
      fecha: [currentDate, [Validators.required], ]
    });
  }

  private formChangesSubscriptions() {
    this.formData.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        if (this.isEditing)
          this.modalSeleccionarCliente.searchByRut(rutCliente)
      })

    this.formData.get("nroPago").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((nroPago: string) => {
        if (this.isEditing) {
          this.log('nroPago change searchByCodigo', this.clienteSeleccionado.rut, Number(nroPago))
          this.modalSeleccionarPago.searchByCodigo(this.clienteSeleccionado.rut, Number(nroPago))
        }
      })
  }

  show() {
    const { currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.isEditing = true
    this.reset()
    this.formData.get('fecha').setValue(currentDate)
    this.modalReversoPago.show()
  }

  loadAndShow(codigo: number) {
    this.reset()
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        codigo
      }
    }
    this.reversaPagoService.obtenerRervesoSegunCodigo(inputParams, ({ mensajes, respuesta: reversoPago }) => {
      const ok = reversoPago !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.log('protesto', reversoPago)
      this.isEditing = false
      this.formData.get('rutCliente').setValue(this.rutService.AgregarDV(reversoPago.cliente_proveedor_rut))
      this.clienteSeleccionado = {}
      this.clienteSeleccionado.nombre = reversoPago.cliente_proveedor_nombre
      this.formData.get('nroPago').setValue(reversoPago.pago_codigo)
      this.pagoSeleccionado = {}
      this.pagoSeleccionado.cliente_proveedor_rut = reversoPago.cliente_proveedor_rut
      this.formData.get('motivo').setValue(reversoPago.motivo)
      this.formData.get('fecha').setValue(reversoPago.fecha)
      this.modalReversoPago.show()
    })
  }

  hide() {
    this.modalReversoPago.hide()
  }

  reset() {
    this.formValidatorsService.reset(this.formData)
    this.clienteSeleccionado = null
    this.pagoSeleccionado = null
  }

  openModalSeleccionarClientes() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data }) {
    this.clienteSeleccionado = data
    this.formData.get('rutCliente').setValue(
      this.rutService.AgregarDV(this.clienteSeleccionado.rut),
      { emitEvent: false },
    )
  }

  onNotFoundCliente() {
    this.clienteSeleccionado = null
  }

  openModalSeleccionarPago() {
    this.modalSeleccionarPago.show(this.clienteSeleccionado.rut)
  }

  onPagoSeleccionado(pago) {
    this.log('pago seleccionado', pago)
    if (pago.puede_reversar === false) {
      const motivo = pago.motivo_bloqueo_reverso || 'Este pago no puede reversarse.'
      this.messageRendererService.showWarningMessages([{ tipo: 'WARNING', texto: motivo }])
      this.pagoSeleccionado = null
      this.formData.get('nroPago').setValue(null)
      return
    }
    this.pagoSeleccionado = pago
    this.formData.get('nroPago').setValue(this.pagoSeleccionado.codigo, { emitEvent: false })
  }

  onNotFoundPago() {
    this.pagoSeleccionado = null
  }

  guardar() {
    this.formValidatorsService.validateAllFormFields(this.formData)
    if (!this.formData.valid)
      return

    const inputParams =
    {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        rut_usuario: this.rutUsuario,
        cliente_proveedor_rut: this.clienteSeleccionado.rut,
        movimiento_pago_codigo: this.pagoSeleccionado.movimiento_pago_codigo,
        monto: this.pagoSeleccionado.monto,
        motivo: this.formData.get('motivo').value,
        pago_codigo: this.pagoSeleccionado.codigo,
        fecha: this.formData.get('fecha').value,
        vendedor_codigo: this.pagoSeleccionado.vendedor_codigo,
      }
    }

    this.log(JSON.stringify(inputParams))

    this.reversaPagoService.guardarReversa(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación realizada con éxito')
      this.hide()
      this.onSave.emit(respuesta)
    })
  }

}
